// extracted by mini-css-extract-plugin
export default {"rootProjects":"vnJDM4sDr9z2vmJ3Gq6G","rootProjectsTitle":"aG6I07XWLWzZRd0gxqJS","rootProjectsList":"qUWmaFTl7CgMx4d8m7iT"};